// frontend/src/components/AdminTeamDetail/ImportConfirmModal.js
import React from 'react';

const ImportConfirmModal = ({ data, onConfirm, onCancel, onChange }) => {
    if (!data) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-[60] flex items-center justify-center p-4">
            <div className="bg-white rounded-lg w-full max-w-md p-6">
                <h3 className="text-xl font-bold mb-4">Confirm Import</h3>
                <p className="text-gray-600 mb-4">
                    Review the player details before adding to the roster.
                </p>
                <div className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Player Name (Editable)</label>
                        <input
                            type="text"
                            className="w-full mt-1 px-3 py-2 border rounded-lg focus:ring-2 focus:ring-mjwc-primary"
                            value={data.customName}
                            onChange={(e) => onChange({ ...data, customName: e.target.value })}
                        />
                    </div>
                    {data.person.images && data.person.images.length > 0 && (
                        <div className="flex items-center gap-3 bg-gray-50 p-2 rounded">
                            <img src={data.person.images[0].url} alt="" className="w-12 h-12 rounded object-cover" />
                            <span className="text-sm text-gray-500">Includes Sportradar Photo</span>
                        </div>
                    )}
                </div>
                <div className="flex justify-end gap-3 mt-6">
                    <button
                        onClick={onCancel}
                        className="px-4 py-2 border rounded-lg text-gray-700 hover:bg-gray-50"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onConfirm}
                        className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700"
                    >
                        Import Player
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ImportConfirmModal;
